"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgPainter = void 0;
var round_1 = require("../../../util/round");
var PathBasedPainter_1 = require("../../PathBasedPainter");
var dompurify_1 = __importDefault(require("dompurify"));
var SvgPainter = /** @class */ (function (_super) {
    __extends(SvgPainter, _super);
    function SvgPainter(_loadSvg, _loadImage, _getLoadingPlaceholder) {
        var _this = _super.call(this, "svg") || this;
        _this._loadSvg = _loadSvg;
        _this._loadImage = _loadImage;
        _this._getLoadingPlaceholder = _getLoadingPlaceholder;
        _this.baseWidthOf = function (object) { return object.width; };
        _this.baseHeightOf = function (object) { return object.height; };
        _this._domPurifier = dompurify_1.default(window);
        return _this;
    }
    SvgPainter.prototype.loadResources = function (store, object) {
        var _this = this;
        store
            .load("svg", function () { return _this._loadSvg(object.url); }, { hash: object.url });
        store
            .load("image", function () { return _this._loadImage(object.url); }, { hash: object.url });
    };
    SvgPainter.prototype.tracePath = function (ctx, store, object) {
        ctx.rect(0, 0, object.width, object.height);
    };
    SvgPainter.prototype.paintFill = function (store, object) {
        var ctx = store.layers.result.ctx;
        var imageResource = store.require("image");
        var image = imageResource.status === "loaded"
            ? imageResource.result
            : this._getLoadingPlaceholder(object);
        ctx.save();
        ctx.scale(object.scaleX, object.scaleY);
        ctx.drawImage(image, 0, 0, round_1.round(object, object.width), round_1.round(object, object.height));
        ctx.restore();
    };
    SvgPainter.prototype.writeSvg = function (ctx, store, object) {
        var svgResource = store.require("svg");
        if (svgResource.status !== "loaded") {
            return;
        }
        var root = this._createSanitizedElement(svgResource.result);
        var viewBox = this._parseViewBox(root);
        root.setAttribute("width", viewBox.width + "px");
        root.setAttribute("height", viewBox.height + "px");
        ctx.save();
        ctx.scale(object.width / viewBox.width, object.height / viewBox.height);
        ctx.insertSvg(root.outerHTML);
        ctx.restore();
    };
    SvgPainter.prototype._createSanitizedElement = function (input) {
        var root = document.createElement("div");
        root.innerHTML = this._domPurifier.sanitize(input);
        return root.children[0];
    };
    SvgPainter.prototype._parseViewBox = function (root) {
        var viewBox = root.getAttribute("viewBox");
        if (viewBox == null) {
            throw new Error("Viewbox missing from svg");
        }
        var dimensions = viewBox.split(" ");
        if (dimensions.length !== 4) {
            throw new Error("Viewbox attribute has incorrect amount of params");
        }
        var width = parseFloat(dimensions[2]);
        var height = parseFloat(dimensions[3]);
        if (isNaN(width) || isNaN(height)) {
            throw new Error("Height or width of is incorrect");
        }
        return { width: width, height: height };
    };
    SvgPainter.prototype.canWriteSvg = function (object) {
        return !object.shadow && !object.stroke;
    };
    SvgPainter.prototype.shouldRepaint = function (previousData, newData) {
        return _super.prototype.shouldRepaint.call(this, previousData, newData)
            || newData.url !== previousData.url;
    };
    return SvgPainter;
}(PathBasedPainter_1.PathBasedPainter));
exports.SvgPainter = SvgPainter;
//# sourceMappingURL=SvgPainter.js.map